import styled from 'styled-components';
import { shallowEqual, useSelector } from 'react-redux';
import { HibraryRootState } from '../../../redux/rootReducer';

interface MaintenanceContainerProps {
    isCu?: boolean;
}

const MaintenanceContainer = styled.div<MaintenanceContainerProps>`
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: ${({ isCu }) =>
        isCu
            ? "url('/images/maintenance/maintenance-background-cu.png')"
            : "url('/images/maintenance/maintenance-background-hibrary.png')"};
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
`;

const Maintenance = () => {
    const { authen } = useSelector(
        (state: HibraryRootState) => ({
            authen: state.auth
        }),
        shallowEqual
    );

    return <MaintenanceContainer isCu={authen.isCuDomain} />;
};

export default Maintenance;
